import { Controller } from "@hotwired/stimulus"

// Shows only the config fields relevant to the selected trigger/action in
// the automation builder form. Sections declare which values they belong to
// via data-for="value1 value2".
export default class extends Controller {
  static targets = ["triggerSelect", "actionSelect", "triggerSection", "actionSection"]

  connect() {
    this.refresh()
  }

  refresh() {
    this.toggle(this.triggerSectionTargets, this.triggerSelectTarget.value)
    this.toggle(this.actionSectionTargets, this.actionSelectTarget.value)
  }

  toggle(sections, selected) {
    sections.forEach(section => {
      const applicable = (section.dataset.for || "").split(/\s+/).includes(selected)
      section.classList.toggle("hidden", !applicable)
    })
  }
}
